import React from 'react';
import { Card, Flex, Typography, Button, Row, Col } from 'antd';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { MenuOutlined, ClockCircleOutlined } from '@ant-design/icons';
import restaurantSelector from '../../redux/selectors/restaurantSelector';
import { getBranchById, getMenuUrl } from '../../utils/branches';

import img1 from '../../assets/breakfast/breakfast1.webp';
import img2 from '../../assets/breakfast/breakfast2.webp';
import img3 from '../../assets/breakfast/breakfast3.webp';

import './UsersBreakfast.css';

function UsersBreakfast() {
  const { number, phoneNumber } = useSelector(restaurantSelector);
  const branch = getBranchById(number);
  if (!branch.hasBreakfast) return null;

  return (
    <>
      <Helmet>
        <title>{`Desayunos en ${branch.name} | Taquito Grill`}</title>
        <meta
          name="description"
          content={`Disfruta los mejores desayunos en ${branch.name} en Taquito Grill. Brunch diario de 8:00 am a 12:00 pm con jugos frescos, platillos fríos, dulces y calientes.`}
        />
      </Helmet>
      <Flex justify="center" className="breakfast-container" id="desayunos">
        <Flex className="container" vertical>
          <Typography.Title level={2} className="breakfast-title">
            {`¡Nuevos Desayunos en ${branch.name}!`}
          </Typography.Title>

          <Card className="breakfast-intro-card">
            <Typography.Paragraph className="intro-text">
              <strong>¡Ya llegaron!</strong>
              {' '}
              Descubre nuestros nuevos desayunos en
              <strong>{` Taquito Grill ${branch.name}`}</strong>
              . El mejor brunch de la ciudad te espera cada mañana.
            </Typography.Paragraph>
            <Typography.Paragraph className="intro-description">
              Ingredientes frescos, sabores auténticos y el ambiente perfecto para comenzar tu día. Desde jugos naturales hasta nuestras especialidades de la casa.
            </Typography.Paragraph>
            <Flex align="center" gap="middle" className="schedule-info">
              <ClockCircleOutlined />
              <Typography.Text>
                <strong>Desayunos:</strong>
                {' '}
                8:00 am - 12:00 pm
              </Typography.Text>
            </Flex>
          </Card>

          <Row gutter={[24, 24]} className="breakfast-categories">
            <Col xs={24} md={8}>
              <Card
                hoverable
                className="category-card"
                cover={<img alt="Bebidas Frescas" src={img3} className="card-image" loading="lazy" />}
              >
                <Card.Meta
                  title="Bebidas Frescas"
                  description={(
                    <>
                      <ul className="category-list">
                        <li>Jugos naturales</li>
                        <li>Café de olla</li>
                        <li>Malteadas</li>
                      </ul>
                      <Button
                        type="link"
                        className="more-options-btn"
                        onClick={() => window.open(getMenuUrl(branch), '_blank')}

                      >
                        + Ver más opciones
                      </Button>
                    </>
                )}
                />
              </Card>
            </Col>

            <Col xs={24} md={8}>
              <Card
                hoverable
                className="category-card"
                cover={<img alt="Platillos Dulces" src={img2} className="card-image" loading="lazy" />}
              >
                <Card.Meta
                  title="Platillos Dulces"
                  description={(
                    <>
                      <ul className="category-list">
                        <li>Hotcakes</li>
                        <li>Frutas con granola</li>
                        <li>Pan francés</li>
                      </ul>
                      <Button
                        type="link"
                        className="more-options-btn"
                        onClick={() => window.open(getMenuUrl(branch), '_blank')}

                      >
                        + Ver más opciones
                      </Button>
                    </>
                )}
                />
              </Card>
            </Col>

            <Col xs={24} md={8}>
              <Card
                hoverable
                className="category-card"
                cover={<img alt="Especialidades" src={img1} className="card-image" loading="lazy" />}
              >
                <Card.Meta
                  title="Especialidades"
                  description={(
                    <>
                      <ul className="category-list">
                        <li>Huevos Taquito Grill</li>
                        <li>Chilaquiles Taquito Grill</li>
                        <li>Omelettes</li>
                      </ul>
                      <Button
                        type="link"
                        className="more-options-btn"
                        onClick={() => window.open(getMenuUrl(branch), '_blank')}

                      >
                        + Ver más opciones
                      </Button>
                    </>
                )}
                />
              </Card>
            </Col>
          </Row>

          <Card className="cta-card">
            <Typography.Paragraph className="cta-text">
              ¿Te antojaste? ¡Ven a probar nuestros nuevos desayunos!
            </Typography.Paragraph>
            <Flex gap="middle" justify="center" wrap className="cta-buttons">
              <Button
                type="primary"
                size="large"
                className="reservation-button"
                onClick={() => window.open(`https://wa.me/52${phoneNumber}?text=Me gustaría reservar una mesa para desayuno`, '_blank')}
              >
                Reservar Mesa
              </Button>
              <Button
                type="default"
                icon={<MenuOutlined />}
                size="large"
                className="menu-button"
                onClick={() => window.open(getMenuUrl(branch), '_blank')}

              >
                Ver Menú Completo
              </Button>
            </Flex>
          </Card>
        </Flex>
      </Flex>
    </>
  );
}

export default UsersBreakfast;
